export default "__VITE_ASSET__Bslbdacn__"